// extracted by mini-css-extract-plugin
module.exports = {"loading":"style_loading__9tiKK","error_box":"style_error_box__CRrIN"};